import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { StyledLabel, SimpleSelectSearch } from '../../FormElements';
import { useTranslation } from 'react-i18next';
import { Spinner } from '../../..';

const StudyProgramPicker = ({ value, onChange, studyPrograms }) => {
  const { t } = useTranslation();

  const studyProgramsOptions = useMemo(() => {
    if (!studyPrograms) {
      return [];
    }

    return studyPrograms.map(({ id, name, shortcut }) => ({
      value: id,
      name: name + ' (' + shortcut + ')',
    }));
  }, [studyPrograms]);

  if (!studyProgramsOptions) {
    return <Spinner />;
  }

  return (
    <>
      <StyledLabel>{t('Študijný program') + ':'}</StyledLabel>
      <SimpleSelectSearch
        onChange={onChange}
        options={studyProgramsOptions}
        value={value === -1 ? studyPrograms[0].id : value}
      />
    </>
  );
};

StudyProgramPicker.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  studyPrograms: PropTypes.array.isRequired,
};

export default StudyProgramPicker;
